import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturFuerstenfeld() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-fuerstenfeld-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-fuerstenfeld-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="fuerstenfeld" />
      </div>
    </div>
  );
}

export default BodentemperaturFuerstenfeld;
